<template>
  <AppAdsense
    ad-style="display:block; text-align:center;"
    ad-layout="in-article"
    ad-format="fluid"
    ad-client="ca-pub-9118328092882671"
    ad-slot="2129288986"
  />
</template>
